import { render, staticRenderFns } from "./OptoutsModal.vue?vue&type=template&id=039a4e2a&scoped=true"
import script from "./OptoutsModal.vue?vue&type=script&lang=js"
export * from "./OptoutsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039a4e2a",
  null
  
)

export default component.exports